<template>
    <div v-bind:class="{ 'active' : isAlertsActive }" class="alerts">
        <slot>
            <button type="button" v-on:click.stop="toggle" title="Alerts">
                <i class="far fa-bell" aria-hidden="true"></i>
                <div v-if="numberOfUnReadAlerts > 0" class="alerts__pill">{{numberOfUnReadAlerts}}</div>
            </button>
            <div v-if="isAlertsActive" class="alerts-container">
                <div class="alerts-modal" v-click-outside.stop="hideAlerts">
                    <div class="alerts-modal__heading">
                        <div class="col text-center">
                            <h6>Alerts</h6>
                        </div>
                    </div>
                    <div class="alerts-modal__list">
                        <ul>
                            <li v-if="alerts.length === 0" class="alert--none">You have no alerts</li>
                            <li v-for="(alert, index) in alerts"
                                v-bind:key="index" class="alert"
                                v-bind:class="{'alert--new' : alert.state === 'new'}"
                                v-bind:title="getTitle(alert)">
                                <div class="alert__automation-type">
                                    <div class="task-icon">
                                        <i v-bind:class="getAlertIcon(alert)"></i>
                                        <i v-bind:class="getStateIconForAlert(alert)"></i>
                                    </div>
                                </div>
                                <div v-on:click="jumpToAct(alert)" class="alert__detail">
                                    <strong>{{alert.message}}</strong>
                                    <template v-if="alert.booking">
                                        <span class="alert__guest">{{alert.booking.bookedBy.firstName}} {{alert.booking.bookedBy.lastName}}</span>
                                        <span class="alert__check-in">Check-in: {{friendlyDate(alert.booking.arrival)}}</span>
                                    </template>
                                    <span v-if="alert.task && alert.task.dueDate" class="alert__timing--overdue">Due: {{friendlyDateAndTime(alert.task.dueDate)}}</span>
                                    <span class="alert__timing--created">{{friendlyDateAndTime(alert.created)}}</span>
                                </div>
                                <div class="alert__actions">
                                    <div v-if="alert.state === 'NEW'" v-on:click.stop="markAlertAsRead(alert)" class="alert__mark-read"></div>
                                    <i v-if="alert.state === 'READ'" v-on:click.stop="acknowledgeAlert(alert)" class="fas fa-times"></i>
                                    <i v-if="alert.state === 'READ'" v-on:click="markAlertAsUnread(alert)" class="fas fa-undo-alt"></i>
<!--                                    For the undo button -->
<!--                                    font-size: 0.8rem;-->
<!--                                    margin-left: -1px;-->
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="alerts-spacer"></div>
            </div>
        </slot>
    </div>
</template>

<script>
    import { store } from '@/store.js'

    import * as dayjs from 'dayjs'

    import {datesMixin} from "../../mixins/DatesMixin"

    export default {
        name: "Alerts.vue",
        props: {
            alerts: Array
        },
        mixins: [datesMixin],
        data: function() {
            return {
                isAlertsOpen: false,
            }
        },
        computed: {
            isAlertsActive: function() {
                // return store.isAlertsOpen
                return this.isAlertsOpen
            },
            numberOfUnReadAlerts: function() {
                let unread = 0;
                if (this.alerts) {
                    for (let alert of this.alerts) {
                        if (alert.state === "NEW") {
                            unread++;
                        }
                    }
                }
                return unread;
            },
        },
        methods: {
            toggle: function() {
                console.log(store.host.alerts);
                this.isAlertsOpen = !this.isAlertsOpen;
            },
            hideAlerts: function() {
                this.isAlertsOpen = false;
            },
            getTitle: function (alert) {
                switch (alert.state) {
                    case 'new':
                        return "Mark as read";
                    case 'read':
                        return "Hide";
                }
                return "";
            },
            getAlertIcon(alert) {
                switch (alert.type) {
                    case 'tour':
                        return 'fas fa-map-signs';
                    case 'booking':
                        return 'fas fa-calendar-alt';
                    case 'task':
                        return 'fab fa-wpforms';
                    default:
                        return 'fas fa-exclamation';
                }
            },
            getStateIconForAlert: function (alert) {
                switch (alert.type) {
                    case 'booking':
                        if (alert.booking) {
                            if (alert.booking.communicationState === 'no-guest-contact-details') {
                                return 'fas fa-question task-state task-state--paused-no-contact-details';
                            }
                            if (alert.booking.state === 'requesting-amendment' || alert.booking.state === 'manually-updating') {
                                return 'fas fa-pause task-state task-state--paused-amending';
                            }
                        }
                        return '';
                    case 'task':
                        if (alert.task.dueDate && dayjs(alert.task.dueDate).isBefore(dayjs())) {
                            return 'fas fa-clock task-state task-state--late';
                        }
                        return '';
                    default:
                        return '';
                }
            },
            jumpToAct: function(alert) {
                console.log(alert);
                switch (alert.type) {
                    case 'tour':
                        if (alert.name === "welcome") {
                            console.log("Starting welcome tour");
                            this.$root.$emit('show-welcome-tour');
                        }
                        break;
                    case 'booking':
                        this.jumpOrScrollCalendar(alert.booking.arrival);
                        break;
                    case 'task':
                        this.jumpOrScrollCalendar(alert.task.scheduledDate);
                        break;
                    default:
                        break;
                }
                this.markAlertAsRead(alert);
                this.isAlertsOpen = false;
            },
            jumpOrScrollCalendar: function(date) {
                const jump = dayjs(date);
                if (this.$router.currentRoute.name === 'JumpToDateOnTaskCalendar' &&
                    this.$router.currentRoute.params.year === jump.format("YYYY") &&
                    this.$router.currentRoute.params.month === jump.format("M") &&
                    this.$router.currentRoute.params.day === jump.format("D")
                ) {
                    this.$root.$emit("calendar-jump-top");
                } else {
                    this.$router.push({name: 'JumpToDateOnTaskCalendar',
                        params: {
                            year: jump.format("YYYY"),
                            month: jump.format("M"),
                            day: jump.format("D"),
                        }
                    });
                }
            },
            markAlertAsRead: function(alert) {
                if (alert.state === 'NEW') {
                    console.log('Marking alert as read')
                    this.$http.put('/guest-management/v1/users/' + store.host.reference + '/alerts/' + alert.reference + '/read').then(() => {
                        alert.state = 'READ';
                    }).catch(error => {
                        console.log(error)
                    });
                }
            },
            markAlertAsUnread: function(alert) {
                if (alert.state === 'READ') {
                    console.log('Marking alert as unread')
                    this.$http.put('/guest-management/v1/users/' + store.host.reference + '/alerts/' + alert.reference + '/unread').then(() => {
                        alert.state = 'NEW';
                    }).catch(error => {
                        console.log(error)
                    });
                }
            },
            acknowledgeAlert: function(alert) {
                console.log('Acknowledging alert')
                this.$http.put('/guest-management/v1/users/' + store.host.reference + '/alerts/' + alert.reference + '/acknowledged').then(() => {
                    for (let i = 0; i < this.alerts.length; i++) {
                        if (this.alerts[i].reference == alert.reference) {
                            this.alerts.splice(i, 1);
                            if (this.alerts.length === 0) {
                                // mutations.toggleAlerts()
                            }
                            break;
                        }
                    }
                }).catch(error => {
                    console.log(error)
                });
            }
        },
        mounted() {
            // let connection = new WebSocket('ws://localhost:3000/');
            // connection.onmessage = (event) => {
                // console.log(event.data);
            // }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/alerts";
    @import "../../styles/components/task_states";
</style>